const strings = {
  'routes/playNow/label': {
    en: 'Play Now',
    fr: 'Jouer',
  },
  'routes/gameInfo/label': {
    en: 'Game Info',
    fr: 'Infos sur le jeu',
  },
  'routes/history/label': {
    en: 'History',
    fr: 'Historique',
  },
  'routes/leaderboard/label': {
    en: 'Leaderboard',
    fr: 'Classement',
  },
};

export default strings;
